// An item's path resolved against the store's types (02-DESIGN/10-state/
// 01-stores-types-and-instances.md § an instance and its path): alternating
// `<type>/<id>` pairs, the first naming the item's type and each further pair
// a child its parent type declares. A path that resolves to nothing is
// untyped, and has no schema to be drawn from.

import type { NamedType } from "../../wire/state.ts";

/** typeAt is the type a path resolves to, or nothing where it is untyped. */
export function typeAt(types: readonly NamedType[], path: string): NamedType | undefined {
  const tokens = path.split("/");
  if (tokens.length < 2 || tokens.length % 2 !== 0) {
    return undefined;
  }
  const byName = new Map(types.map((t) => [t.name, t]));
  let t = byName.get(tokens[0] ?? "");
  for (let i = 2; t !== undefined && i < tokens.length; i += 2) {
    const child = t.children?.[tokens[i] ?? ""];
    t = child === undefined ? undefined : byName.get(child);
  }
  return t;
}

/** schemaAt is the schema of the type a path resolves to, or nothing. */
export function schemaAt(types: readonly NamedType[], path: string): unknown {
  return typeAt(types, path)?.schema;
}
